import React, { useEffect, useState } from 'react';
import headers from './model';

const HeadersComponent = (props) => {
  const { websiteDetails } = props;
  const [headerNumber, setHeaderNumber] = useState(websiteDetails.headersNumber || 1);
  const [isOwner, setIsOwner] = useState(websiteDetails.isOwner || false);
  useEffect(() => {
    setHeaderNumber(websiteDetails.headersNumber || 1);
    setIsOwner(websiteDetails.isOwner);
  }, [websiteDetails]);
  const HeaderComponent = headers[headerNumber];
  return (
    <div>
      {HeaderComponent ? <HeaderComponent {...props} /> : <> </>}
      {isOwner && <div />}
    </div>
  );
};

export default HeadersComponent;
